import { useId } from 'react';

// Bandeiras do seletor de idioma, desenhadas em SVG (recorte circular, sem imagem externa).
// Simplificadas para o tamanho de ícone: sem estrelas nem brasão.
const DESENHOS = {
  pt: (
    <>
      <rect width="24" height="24" fill="#009C3B" />
      <polygon points="2,12 12,4.5 22,12 12,19.5" fill="#FFDF00" />
      <circle cx="12" cy="12" r="4.6" fill="#002776" />
      <path d="M7.6 11.2 C10.5 10.4 13.8 10.9 16.5 12.6" stroke="#fff" strokeWidth="0.9" fill="none" />
    </>
  ),
  en: (
    <>
      {Array.from({ length: 13 }, (_, i) => (
        <rect key={i} y={(i * 24) / 13} width="24" height={24 / 13 + 0.05} fill={i % 2 ? '#fff' : '#B22234'} />
      ))}
      <rect width="11" height={(7 * 24) / 13} fill="#3C3B6E" />
    </>
  ),
  es: (
    <>
      <rect width="24" height="24" fill="#AA151B" />
      <rect y="6" width="24" height="12" fill="#F1BF00" />
    </>
  ),
};

/** Bandeira redonda do idioma (`pt`, `en` ou `es`). */
export default function Bandeira({ idioma, titulo, size = 22 }) {
  const recorte = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={titulo} style={{ display: 'block' }}>
      <clipPath id={recorte}>
        <circle cx="12" cy="12" r="12" />
      </clipPath>
      <g clipPath={`url(#${recorte})`}>{DESENHOS[idioma] ?? DESENHOS.pt}</g>
    </svg>
  );
}
